import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/new_win.svg'


const _hoisted_1 = { class: "projects-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "projects-title" }, "Work", -1)
const _hoisted_3 = { class: "projects" }
const _hoisted_4 = {
  id: "project-1",
  class: "project-content"
}
const _hoisted_5 = { class: "project-description" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Intelligent voice-activated lab assistant for extraterrestrial missions ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "arrow-right" }, null, -1)
const _hoisted_8 = {
  id: "project-2",
  class: "project-content"
}
const _hoisted_9 = { class: "project-description" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Mobile instant messaging app to build meaningful connections with others ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "arrow-right" }, null, -1)
const _hoisted_12 = {
  id: "project-3",
  class: "project-content"
}
const _hoisted_13 = { class: "project-description" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " Telegram chatbot to bring awareness to plastic consumption and support new habits ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "arrow-right" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "projects-learnmore" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://digitalmedia-bremen.de/student/ana-rita-freitas/",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "learnmore-link"
  }, [
    /*#__PURE__*/_createTextVNode("see additional projects featured on my Master's program website "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "open in new window"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: { name: 'Cassiopeia' } }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, { to: { name: 'Apart' } }, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, { to: { name: 'Otto' } }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_16
    ])
  ]))
}